<template>
  <table class="table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="min-width">№</th>
        <th scope="col" class="min-width">Club</th>
        <th scope="col" class="min-width">Score</th>
        <th></th> <!-- empty column for alignment -->
      </tr>
    </thead>
    <tr
      v-for="(record, index) in rating"
      :key="record.entityId"
    >
      <td class="num">
        {{index + 1 | getFormattedNumber}}
      </td>
      <td>
        <club-link :clubId="record.entityId" />
      </td>
      <td class="num">
        <b-button v-b-modal.players-modal size="sm" @click="loadPlayer(record)" variant="link">
          {{record.score | getFormattedNumber}}
        </b-button>
      </td>
      <td></td>
    </tr>
    <b-modal id="players-modal" title="Players" ok-only ok-title="Close" size="xl">
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <th>Player</th>
          <th>Scores</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(record, index) in players" :key="index">
          <td>
            <b-link :to="{name: 'player_info', params: { playerId: record.entityId }}">
              {{ record.entityId }}
            </b-link>
          </td>
          <td>{{ record.score }}</td>
        </tr>
        </tbody>
      </table>
    </b-modal>
  </table>
</template>

<script>
import ClubLink from '../ClubLink.vue';
import notifier from "@/notifier";
import {HTTP} from "@/http-common";

export default {
  name: 'BakeryMarathonRating',

  components: {
    ClubLink,
  },

  props: {
    rating: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      players: [],
    };
  },

  methods: {
    loadPlayer(record) {
      notifier.deleteSenderNotifications(this);

      if (record.score == 0) {
        this.players = [];
        return;
      }

      let contestId =  this.$route.params.contestId
      let groupId =  this.$route.params.groupId


      HTTP.get(`/contest/${contestId}/group/${groupId}/${record.entityId}/player_scores`)
          .then(response => {
            const data = response.data.data;
            if(data === null) {
              notifier.showError('Invalid server response. data === null.', {sender: this});
              return;
            }
            this.players = data.rating || [];
          })
          .catch(e => {
            notifier.showError(e, {sender: this});
          });
    },
  },
};

</script>

<style scoped>
.num {
  text-align: right;
}

.min-width {
  width: 1px;
}

.table td {
  vertical-align: unset;
}
</style>
